module.exports = "<dx-load-panel #loadPanel [(visible)]=\"loadingVisible\" \n                [showPane]=\"true\" \n                [shading]=\"true\" \n                [(message)]=\"loadingMessage\">\n</dx-load-panel>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/loading/loading.component.html
// module id = ./src/app/components/loading/loading.component.html
// module chunks = main